import BigNumber from 'bignumber.js';
import { DlVault } from 'types/contracts';

export interface GetNetworkRewardRulesInput {
  dlVaultContract: DlVault;
  accountAddress: string;
}

export type GetNetworkRewardRulesOutput = {
  rewardRules: {
    generation: string;
    requirement: string;
    rate: string;
    percentage: BigNumber;
    levels: number[];
  }[];
  totalLevels: number;
  baseRewardRate: BigNumber;
  maxRewardRate: BigNumber;
};

const getNetworkRewardRules = async ({
  dlVaultContract,
  accountAddress,
}: GetNetworkRewardRulesInput): Promise<GetNetworkRewardRulesOutput> => {
  try {
    // 调用实际的合约方法
    const result = await dlVaultContract.methods
      .getNetworkRewardRules()
      .call();

    const { generations, requirements, rates } = result;

    // 解析合约返回的数据并转换为前端需要的格式
    const rewardRules = generations.map((generation: string, index: number) => {
      const rateStr = rates[index];
      const percentageValue = parseFloat(rateStr.replace('%', ''));

      // 根据generation确定对应的层级范围
      let levels: number[] = [];
      switch (index) {
        case 0: // 1st generation
          levels = [1];
          break;
        case 1: // 2nd generation
          levels = [2];
          break;
        case 2: // 3rd-7th generation
          levels = [3, 4, 5, 6, 7];
          break;
        case 3: // 8th-17th generation
          levels = [8, 9, 10, 11, 12, 13, 14, 15, 16, 17];
          break;
        default:
          levels = [];
          break;
      }

      return {
        generation,
        requirement: requirements[index],
        rate: rateStr,
        percentage: new BigNumber(percentageValue),
        levels,
      };
    });

    return {
      rewardRules,
      totalLevels: 17,
      baseRewardRate: new BigNumber('1'), // 最低1%
      maxRewardRate: new BigNumber('10'), // 最高10%
    };
  } catch (error) {
    console.error('Error fetching network reward rules:', error);
    // 如果合约方法调用失败，返回默认规则
    const defaultRules = [
      {
        generation: '1st generation',
        requirement: 'Direct referrals >= 1',
        rate: '10%',
        percentage: new BigNumber('10'),
        levels: [1],
      },
      {
        generation: '2nd generation',
        requirement: 'Direct referrals >= 2',
        rate: '5%',
        percentage: new BigNumber('5'),
        levels: [2],
      },
      {
        generation: '3rd-7th generation',
        requirement: 'Direct referrals >= 3',
        rate: '2%',
        percentage: new BigNumber('2'),
        levels: [3, 4, 5, 6, 7],
      },
      {
        generation: '8th-17th generation',
        requirement: 'Direct referrals >= 4',
        rate: '1%',
        percentage: new BigNumber('1'),
        levels: [8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
      },
    ];

    return {
      rewardRules: defaultRules,
      totalLevels: 17,
      baseRewardRate: new BigNumber('1'),
      maxRewardRate: new BigNumber('10'),
    };
  }
};

export default getNetworkRewardRules;
